import EMVERSITY from "@/assets/industry-co-led/partners/EMVERSITY.png";
import Icon1 from "@/assets/industry-co-led/logo/madel.png";
import Icon2 from "@/assets/industry-co-led/logo/network.png";

import Student1 from "@/assets/students/student1.png";
import Student2 from "@/assets/students/student2.png";
import Student3 from "@/assets/students/student3.png";
import Student4 from "@/assets/students/student4.png";



const OJLImg1 = "https://cdn.msu.edu.in/medium_indra_e3fb4b54e8.webp";
const OJLImg2 = "https://cdn.msu.edu.in/medium_Lalita_62a0510f98.webp";
const OJLImg3 = "https://cdn.msu.edu.in/medium_Bishnu_fc22ecf771.webp";
const OJLImg4 = "https://cdn.msu.edu.in/medium_Kabita_ebbc6b08da.webp";
const OJLImg5 = "https://cdn.msu.edu.in/medium_MAMTA_913133c765.webp";
const OJLImg6 = "https://cdn.msu.edu.in/medium_Subba_c2f59607bc.webp";

const Img1 = "https://cdn.msu.edu.in/art_1_4db33f9751.webp";
const Img2 = "https://cdn.msu.edu.in/Operation_Theatre_a23819fff5.webp";
const Img3 = "https://cdn.msu.edu.in/emergency_medical_technology_ffa5f7bfc0.webp";
const Img4 = "https://cdn.msu.edu.in/Dialysis_Unit_cf4b5c7b58.webp";
const Img5 = "https://img.youtube.com/vi/lTWke3-IGz4/hqdefault.jpg";

export const anaesthesiaAndOTT = {
  heroSection: {
    breadcrumb: [
      { name: "Home", url: "/" },
      {
        name: "Industry Co-led UG Programmes",
        url: "/industry-co-led-ug-programmes",
      },
      {
        name: "Bachelors in Anaesthesia & Operation Theatre Technology",
        url: "",
      },
    ],
    bannerImg: "https://img.youtube.com/vi/lTWke3-IGz4/hqdefault.jpg",
    title: "Bachelors in Anaesthesia & Operation Theatre Technology",
    poweredBy: {
      text: "Industry Skilling Partner",
      logo: EMVERSITY,
    },
    duration: "4 Year Undergraduate Degree Programme",
    description:
      "Learn about Physiology, Biochemistry & Haematology, Anaesthesia Techniques, Basic Intensive Care and more",
    stats: [
      {
        value: "Up to 70%",
        label: "Practical Curriculum",
      },
      {
        value: "Paid",
        label: "On-the-job learning",
      },
      {
        value: "100%",
        label: "Placement Assistance",
      },
    ],
    buttons: {
      download: "Download Brochure",
      enroll: "Enroll Now",
    },
    video: {
      thumbnail: "https://img.youtube.com/vi/1Czt5IproZU/maxresdefault.jpg",
      buttonText: "Watch Programme Video",
      url: "https://www.youtube.com/embed/1Czt5IproZU?si=dLl29ZKSgwu-Lc7D",
    },
  },

  aboutSection: {
    tag: "ABOUT THE PROGRAMME",
    title: "Bachelors in Anaesthesia & Operation Theatre Technology",
    description: [
      "Bachelors in Anaesthesia & Operation Theatre Technology is a four-year undergraduate program that prepares students to become skilled anesthesia technologists and operation theatre professionals. The program covers pre-operative assessment, anaesthesia delivery assistance, patient monitoring during surgery, OT equipment management, sterilisation protocols and post-operative care. Students develop competence in airway management, ventilator operation and emergency response within surgical environments.",
      "This program at Medhavi Skills University is delivered through a unique partnership model: MSU provides the academic framework, degree conferral, examinations and campus infrastructure, while Emversity delivers the industry-skilling component, including AR/VR simulation-based training, employer-co-designed curriculum modules, structured clinical internships and placement assistance through its network of 500+ healthcare employer partners.",
    ],
    stats: [
      { value: "Up to 70%", label: "Practical Curriculum" },
      { value: "Paid", label: "Paid on-the-job learning" },
      { value: "100%", label: "Placement Assistance" },
    ],
    approvals: [
      "UGC Approved",
      "NEP 2020 Aligned",
      "Govt. Scholarships Available",
    ],
    journeyTitle: "Your 4-Year Journey",
    journey: [
      {
        phase: "YEAR 1",
        title: "Biomedical Foundations",
        description:
          "Human Physiology, Basic Nursing & First Aid, Environmental Science and more",
      },
      {
        phase: "YEAR 2",
        title: "Core Anaesthesia & OT Sciences",
        description:
          "Pathology, Sterilisation & Infection Control, OT Design, Layout & Protocols and more",
      },
      {
        phase: "YEAR 3",
        title: "Advanced Anaesthesia & Specialisations",
        description:
          "Get insights into Advanced Airway Management, Orthopaedic & Trauma Anaesthesia and more",
      },
      {
        phase: "YEAR 4",
        title: "Clinical Practice & Professional Readiness",
        description:
          "Get the opportunity to learn and earn in industry through paid OJL",
      },
      {
        phase: "GRADUATE",
        title: "Bachelors in Anaesthesia & Operation Theatre Technology",
        description: "Industry-ready healthcare professional",
      },
    ],
  },

  offeringSection: {
    tag: "OUR OFFERING",
    title: {
      first: "Comprehensive",
      highlight: "Healthcare Management Education",
    },
    description:
      "We offer a UGC-approved, 4 years undergraduate programme, Bachelors in Anaesthesia & Operation Theatre Technology. It is an industry-aligned healthcare degree designed to build strong skills and prepare students for diverse roles.",
    learningBox: {
      title: "Key Areas of Learning",
      points: [
        "Basics Healthcare Delivery System in India",
        "Medical Law & Ethics",
        "Basics of Surgical Procedures",
        "Advanced Anaesthesia Techniques",
        "Specialized Surgery",
        "Research Methodology & Biostatistics"
      ],
    },
    image: "https://cdn.msu.edu.in/operation_po_2_8a05b61cd7.jpg",
  },

  whyEMT: {
    tag: "WHY ANESTHESIA AND OT. WHY NOW.",
    title: "Be the Backbone of Critical Care When Every Second Matters",
    description:
      "Our Bachelors in Anaesthesia & Operation Theatre Technology aligns with evolving healthcare demands, combining strong clinical knowledge with hands-on training to prepare skilled professionals for high-stakes medical environments.",
    stats: [
      {
        value: "100%",
        text: "of major surgeries require anesthesia and operation theatre support",
      },
      {
        value: "300 million+",
        text: "surgical cases are performed globally each year, driving continuous demand for trained OT and anesthesia technologists",
      },
    ],
  },

  msuAdvantages: {
    tag: "MSU ADVANTAGES",
    title: "Programme by Emversity, Delivered at MSU Campus",
    description:
      "Your edge at Medhavi Skills University, where real-world learning, industry exposure and future-ready skills come together.",
    cards: [
      {
        number: "01",
        text: "Only university in Sikkim aligned with paid On-the-Job Learning embedded curriculum for practical learning",
      },
      {
        number: "02",
        text: "Only university in Sikkim to ensure 100% of our student applicants receive government scholarships",
      },
      {
        number: "03",
        text: "Well-equipped labs, advanced training setups and hands-on field training",
      },
    ],
    pointerTitle: "Highlights from The Programme:",
    highlights: [
      "Programme aligned with NEP 2020, focused on Learning Outcome Based Education",
      "Up to 70% practical based curriculum",
      "Paid On-the-Job Learning (OJL)",
      "Industry-aligned curriculum & hands-on learning",
      "Learn from seasoned medical professionals",
      "Immersive industry exposure through industry visits, guest lectures and networking opportunities",
      "Opportunity to 'learn and earn' through immersive on-the-job learning, industry projects and internships with leading companies",
      "Engage with industry experts to get invaluable insights and real-world perspectives",
    ],
    image: "https://cdn.msu.edu.in/msu_advantages_8519d5e66d.webp",
  },

  CTA: {
    title: "Start Your Journey in Critical Care with Emversity's",
    highlights: "Bachelors in Anaesthesia & Operation Theatre Technology",
    url: "#",
    btnName: "Apply Now",
  },

  onJobtrainningData: {
    tag: "HANDS-ON EXPERIENCE",
    title: "On-the-Job Learning",
    description:
      "At Medhavi Skills University, On-the-Job Learning (OJL) enables students to gain real industry experience and earn a stipend while they learn.",
    images: [
      { id: 1, src: OJLImg1, alt: "Student assisting in operation theatre" },
      { id: 2, src: OJLImg2, alt: "Student working with anaesthesia equipment" },
      { id: 3, src: OJLImg3, alt: "Student in surgical training environment" },
      { id: 4, src: OJLImg4, alt: "Student monitoring patient vitals" },
      { id: 5, src: OJLImg5, alt: "Student handling OT instruments" },
      { id: 6, src: OJLImg6, alt: "Student in clinical internship setting" },
    ],
  },

  addtionSkill: {
    courseSections: {
      AdditionalSkills: {
        tag: "BONUS CREDENTIALS",
        title: "Additional Skills Certifications",
        description:
          "At Medhavi Skills University, students have the opportunity to gain credible Skill Certifications like Basic Life Support (BLS), Advanced Cardiovascular Life Support (ACLS), Infection Control & Biomedical Waste Management and more. These certifications, earned alongside the degree, enhance credibility, strengthen industry relevance and prepare students for employment with nationally and globally recognised credentials.",
        image: {
          url: "https://cdn.msu.edu.in/small_DSC_00454_1_bd0fe5be1d.jpg",
          alternativeText: "Skill Certification",
        },
        items: [
          {
            id: 1,
            text: "Basic Life Support (BLS) & Advanced Cardiovascular Life Support (ACLS) Certifications",
            icon: Icon2,
          },
          { id: 2, text: "Nationally & Globally Recognised", icon: Icon1 },
        ],
        button: { text: "Apply Now", link: "/apply" },
      },
    },
  },

  DoExperienceLearndata: {
    tag: "INFRASTRUCTURE",
    title: "Do-Experience-Learn",
    description:
      "Discover the advantage of MSU's cutting-edge infrastructure, featuring modern laboratories, classrooms and industry-relevant facilities",
    images: [
      { id: 1, src: Img1, size: "large", alt: "Classrooms" },
      { id: 2, src: Img2, size: "large", alt: "Operation Theatre Labs" },
      { id: 3, src: Img3, size: "small", alt: "Anaesthesia Equipment" },
      { id: 4, src: Img4, size: "small", alt: "Surgical Training Setup" },
      { id: 5, src: Img5, size: "small", alt: "Virtual Campus Tour" },
    ],
  },

  studentStoriesData: {
    title: "Medhavians Speak",
    subText: "These stories reflect what happens when learning goes beyond theory. From hands-on training to real-world exposure, our students build skills that translate directly into careers.",
    students: [
      {
        name: "Radhika Chettri",
        image: Student2,
        videLink:
          "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-Long.mp4",
        shortUrl:
          "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-short.mp4",
      },
      {
        name: "Pratik Chettri",
        image: Student3,
        videLink:
          "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science-Long.mp4",
        shortUrl:
          "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science+-short.mp4",
      },
      {
        name: "Suhana Sharma",
        image: Student4,
        videLink:
          "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-Long.mp4",
        shortUrl:
          "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-short.mp4",
      },
      {
        name: "Hissey Bhutia",
        image: Student1,
        videLink:
          "https://cdn.msu.edu.in/Student-Testimonials/Nursing-Long.mp4",
        shortUrl:
          "https://cdn.msu.edu.in/Student-Testimonials/Nursing-short.mp4",
      },
    ],
  },

  eligibility: {
    tag: "ELIGIBILITY",
    title: "Who Can Apply?",
    description:
      "12th Pass (10+2) with Physics, Chemistry and Biology/Mathematics as core subjects",
    button: { text: "Apply Now", url: "" },
    items: [
      {
        title: "12th Pass - Science Stream",
        text: "Candidates who have passed 10+2 with Physics, Chemistry and Biology/Mathematics as core subjects are eligible to apply for the Bachelors in Anaesthesia & Operation Theatre Technology programme.",
      },
    ],
  },

  careerProspects: {
    tag: "CAREER PROSPECTS",
    heading: "Career Prospects",
    description:
      "Join Bachelors in Anaesthesia & Operation Theatre Technology programme and embark on a rewarding journey in healthcare industry",
    roles: [
      "Anesthesia Technician",
      "Operation Theatre Technician",
      "Surgical Technologist",
      "Anesthesia Assistant",
      "OT Assistant",
      "Emergency OT Technician",
      "ICU Technician",
      "Anaesthesia Equipment Technician",
      "Surgical Instrument Technician",
      "CSSD Technician (Central Sterile Supply Department)",
      "Clinical Support Technician",
      "Operation Theatre Supervisor",
      "Anesthesia Care Coordinator",
      "Surgical Unit Assistant",
      "Healthcare Technician",
    ],
  },

  curriculumStructure: {
    label: "WHAT YOU WILL LEARN",
    heading: "Curriculum Structure",
    description:
      "Step into a future-focused learning environment with industry-oriented programmes designed to build practical skills, real-world readiness and broad career opportunities across disciplines.",
    semesters: [
      {
        name: "Semester 1",
        title: "Building Foundations in Healthcare Sciences and Patient Care",
        description: "The first semester establishes the foundational knowledge required for a career in anaesthesia technology and perioperative care. Students develop an understanding of human anatomy, physiology, healthcare systems, and medical terminology, enabling them to comprehend the clinical and operational aspects of patient management. The curriculum also introduces healthcare quality standards and patient safety principles, helping learners build a strong foundation in safe clinical practices, professional responsibilities, and the essential concepts that support effective anaesthesia and surgical care services.",
        subjects: [
          { name: "Basics Healthcare Delivery System in India", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Medical Terminology & Record Keeping", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Anatomy", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Physiology", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "Healthcare Quality & Patient Safety", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" }
        ]
      },
      {
        name: "Semester 2",
        title: "Developing Clinical Foundations in Anaesthesia and Surgical Sciences",
        description: "The second semester builds upon core healthcare sciences by introducing students to the medical, ethical, and scientific principles that support anaesthesia and surgical care. Learners gain an understanding of biomedical sciences, pharmacology, pathology, microbiology, and hematology, enabling them to appreciate the physiological and clinical considerations involved in perioperative patient management. The curriculum also emphasizes professional ethics, management principles, communication skills, and digital literacy, helping students develop the knowledge and competencies required to function effectively within surgical and anaesthesia teams.",
        subjects: [
          { name: "Medical Law & Ethics", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Principles of Management", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Basics of Biomedical Sciences in Surgery & Anaesthesia", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Biochemistry & Hematology", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "Pathology & Microbiology", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
          { name: "Basic Concept in Pharmacology", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
          { name: "Basic Computers and Information Sciences", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" },
          { name: "Communication and Soft Skills", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" }
        ]
      },
      {
        name: "Semester 3",
        title: "Building Technical Competence in Anaesthesia and Surgical Support",
        description: "The third semester introduces students to the practical aspects of anaesthesia administration and surgical support services. Learners develop an understanding of anaesthesia techniques, surgical procedures, sterilization processes, and the operational functions of critical support areas such as CSSD and manifold systems. The curriculum also incorporates industry exposure through orientation and site visits, enabling students to gain insights into real-world healthcare environments. This combination of technical learning and practical exposure helps students strengthen their readiness for clinical and perioperative care settings.",
        subjects: [
          { name: "Basic Techniques of Anaesthesia", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Basics of Surgical Procedures", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "CSSD & Manifold Area", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Industrial Orientation & Industrial Visit", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" }
        ]
      },
      {
        name: "Semester 4",
        title: "Advancing Perioperative Care and Critical Care Management",
        description: "The fourth semester focuses on advanced anaesthesia practices, complex surgical procedures, and the management of critically ill patients. Students develop a deeper understanding of anaesthesia techniques, perioperative patient care, and the clinical considerations involved in supporting a wide range of surgical interventions. The curriculum also introduces intensive care concepts and clinical management principles, enabling learners to strengthen their decision-making abilities, technical proficiency, and readiness to function effectively within operating theatres and critical care environments.",
        subjects: [
          { name: "Advanced Anaesthesia Techniques", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Advanced Surgical Procedures", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Basic Intensive Care", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Clinical Medicine & Management", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" }
        ]
      },
      {
        name: "Semester 5",
        title: "Mastering Specialized Anaesthesia and Surgical Care",
        description: "The fifth semester focuses on specialized areas of anaesthesia and surgical practice, enabling students to develop advanced knowledge of complex procedures and evolving clinical techniques. Learners gain exposure to specialized anaesthesia applications, advanced surgical interventions, and recent innovations shaping modern perioperative care. The curriculum also introduces disaster management and environmental considerations in healthcare, helping students understand emergency preparedness, risk management, and sustainable healthcare practices. This semester strengthens clinical competence and prepares students for increasingly specialized roles within surgical and critical care settings.",
        subjects: [
          { name: "Specialized Anaesthesia", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Specialized Surgery", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Recent Advances in Anaesthesia & Surgical Fields", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Disaster Management & Environmental Science", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" }
        ]
      },
      {
        name: "Semester 6",
        title: "Refining Expertise in Advanced Anaesthesia and Surgical Practice",
        description: "The sixth semester further strengthens students' expertise in specialized anaesthesia and surgical care through advanced clinical concepts and procedure-oriented learning. Learners gain deeper insights into complex perioperative techniques, specialized patient management, and evolving practices across surgical disciplines. The curriculum also introduces research methodology and biostatistics, enabling students to develop analytical skills and an evidence-based approach to clinical decision-making. This combination of advanced clinical knowledge and research competency prepares students for higher levels of responsibility in anaesthesia and surgical care settings.",
        subjects: [
          { name: "Specialized Anaesthesia – II", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Specialized Surgery – II", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Specialized Anaesthesia & Surgical – III", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Research Methodology & Biostatistics", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" }
        ]
      },
      {
        name: "Semester 7 & 8",
        title: "Integrating Anaesthesia and Surgical Expertise Through Clinical Practice",
        description: "The internship phase provides students with extensive hands-on exposure across anaesthesia, surgery, and specialized clinical departments, enabling them to apply their academic knowledge in real-world healthcare settings. Through structured rotations, learners gain practical experience in perioperative care, anaesthesia administration, surgical assistance, patient monitoring, and multidisciplinary collaboration. Exposure to diverse specialties helps strengthen clinical competence, technical proficiency, and professional confidence while fostering a deeper understanding of patient care pathways. This immersive training prepares graduates for seamless transition into professional roles within operation theatre, anaesthesia, and surgical care environments.",
        subjects: [
          { name: "AOTT Internship (Including Six Months of Anaesthesia, Six Months of Surgery, and Rotations Across Specialty Departments)", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" }
        ]
      },
      {
        name: "Value Addition",
        title: "Value-Added Learning Opportunities",
        description: "Students gain access to skill certifications, semester-wise workshops, and industry visits that enhance practical learning and professional development. Additionally, aspiring entrepreneurs can explore venture creation opportunities with mentorship, incubation support, and access to funding through the Medhavi NextGen Innovation and Incubation Center and government-backed initiatives.",
        "keySubjectsLabel": "Key Features",
        subjects: [
          { "name": "Skill certifications", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
          { "name": "One workshop per semester", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
          { "name": "One industry visit per semester", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
          { "name": "Opportunity for venture creation through university and government funding (Medhavi NextGen Innovation and Incubation Center)", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" }
        ],
        "learningOutcomes": [
          "Gain real-world experience through the Red.Health Network internship",
          "Execute industry-based projects in healthcare settings",
          "Complete a capstone project and dissertation",
          "Transition confidently into healthcare management roles",
          "Prepare professionally through CV launch and career readiness activities"
        ]
      }
    ],
  },

  faq: {
    id: 105,
    title: "Bachelors in Anaesthesia & Operation Theatre Technology",
    FAQ: [
      {
        id: 1,
        Question: "What is the university's role and what is Emversity's role?",
        Answer:
          "MSU manages all academic matters — admissions, examinations, marksheets, transcripts and degree conferral. All fees are payable directly to the university. Emversity is the industry-skilling partner and delivers AR/VR simulation training, industry-co-designed skill modules, clinical internship facilitation, placement assistance and the Cambridge English program. Emversity does not collect fees, conduct exams, or award degrees.",
      },
      {
        id: 2,
        Question: "Is placement or internship stipend guaranteed?",
        Answer:
          "Emversity provides placement assistance through its network of 500+ healthcare employer partners and facilitates structured clinical internships. However, placement is not guaranteed and stipend amounts vary by employer. Final hiring and stipend decisions rest with the host institution.",
      },
      {
        id: 3,
        Question: "Is this program recognised and is it full-time?",
        Answer:
          "Yes, this is a full-time, on-campus program. MSU is established under the Medhavi Skills University, Sikkim Act, 2021 and is recognised by the UGC under Section 2(f). The curriculum is aligned with the NCAHP Act 2021 framework. Students should verify current NCAHP notifications and state council registration requirements directly with the university.",
      },
      {
        id: 4,
        Question: "How do I apply?",
        Answer:
          "Applications are submitted through MSU's official admissions portal. Candidates may be required to appear for the Medhavi Scholarship & Aptitude Test (MSAT). For eligibility verification, fee details and application deadlines, please contact the MSU admissions office directly.",
      },
      {
        id: 5,
        Question: "What is the Head Start Programme?",
        Answer:
          "The Head Start Programme is a zero-cost, online bridge course offered before classes begin. It covers foundational concepts and essential skills for your chosen field. Participation is voluntary, non-credit-bearing and does not affect admission status or academic standing. Students who successfully complete it receive a complimentary laptop and may be eligible for additional scholarships.",
      },
      {
        id: 6,
        Question: "Is this programme NCAHP aligned?",
        Answer:
          "Yes. The curriculum is subject to periodic revision by MSU in alignment with NCAHP guidelines and evolving industry requirements. Students should refer to the university's official academic notifications for the latest syllabus.",
      },
    ],
  },

  coursePrice: { price: "₹8,00,000" },
};